import { createFileRoute } from '@tanstack/react-router'
import { LegalNoticesPage } from '@/pages/LegalNoticesPage'
import { ROUTES } from '@/constants/routeConstants.ts'

const App = () => {
  return <LegalNoticesPage />
}

export const Route = createFileRoute(ROUTES.LEGAL_NOTICES)({
  component: App,
})
